// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["web/app/themes/v1/css/sass.min"], () => (__webpack_require__("./web/app/themes/v1/js/global.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["web/app/themes/v1/css/sass.min"], () => (__webpack_require__("./web/app/themes/v1/sass/main.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
